import { PureComponent } from 'react';
import DocuViewareService from '../../common/services/docuViewareService';
import { getDocuViewareId } from '../../common/helpers/docuViewareHelper';
import Utilites from '../../common/helpers/utilities';
import DocuViewareMode from '../../constants/docuViewareConfigurations';
import { Metadata } from '../../common/metadata';
import i10n from '../../common/i10n';
import $ from 'jquery'
import { AsyncSVG } from '../../common/components/AsyncSVG';

export class DocumentViewer extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            viewerAvailable: false,
            docuviewareControlId: getDocuViewareId(Utilites.generateGUID())
        };
    }

    componentDidMount() {

        var docuviewareConfig = {
            fileId: "",
            controlId: this.state.docuviewareControlId,
            controlWidth: "100%",
            controlHeight: "100%",
            DocuViewareMode: DocuViewareMode.VIEW_DOCUMENT
        };

        DocuViewareService.docuviewareGetControl(docuviewareConfig).then((resp) => {
            this.setState({
                viewerAvailable: true
            });

            var response = resp.data;

            if (response.success) {
                $("#docuviewareControl").html(response.element); //Scritp tag doesn't work with <div id="dvContainer" dangerouslySetInnerHTML={{ __html: this.state.viewerRawHtml }}></div>)
                
            }
            else {
                alert(response.errorMessage != null ? response.errorMessage : i10n._VIEW_DOCUMENTVIEWER_GET_DOCUVIEWARE_FAILURE_MESSAGE);
            }
        },
            (error) => {
                var errorMessage = error.response?.data && typeof error.response?.data == "string" ?
                    error.response.data : error.response?.statusText || i10n._VIEW_DOCUMENTVIEWER_GET_DOCUVIEWARE_FAILURE_MESSAGE + ' ' + error.message;
                alert(errorMessage);
            });
    }

    render() {
        return (
            <div className={`w-100 h-100 ${this.state.viewerAvailable ? '' : 'document-viewer-loading-wrapper'}`}>
                {
                    <Metadata />
                }
                {
                    !this.state.viewerAvailable &&
                    <AsyncSVG className="document-viewer-loader" src="/images/black-avepdf-svg-loading.svg" />
                }
                <div id="docuviewareControl" className="w-100 h-100"></div>
            </div>
        );
    }
};

export default DocumentViewer;